import React from 'react';

import Card from '../components/Statics'
import useUserLength from '../hooks/UseUsersLenght';

const DashboardCards = () => {
    const {userLength, error: userLengthError} = useUserLength();
    
    return (

            
            <main>
                <div className="header">
                    <div className="left">
                        <h1>Главная</h1>
                        <ul className="breadcrumb">
                            <li>
                                <a href="#">
                                    Главная
                                </a>
                            </li>
                            /
                            <li>
                                <a href="#" className="active">Бот</a>
                            </li>
                        </ul>
                    </div>
                </div>


                <ul className="insights">
                <Card className="bx bx-child" h3={userLength} p="Пользователей" />
                {/*<Card className="bx bx-child" h3={userLengthTheApplication} p="Ожидающие подтверждения" />*/}
                    
                </ul>
            </main>
    );
};

export default DashboardCards;